var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-studio-container"},[_vm._l((Object.keys(_vm.blocks)),function(block){return _c('div',[(_vm.fit20.blockNameToEdit == block)?_c(_vm.blocks[block],{tag:"component",attrs:{"fit20":_vm.fit20,"saveBlock":_vm.saveBlock,"cancelEditing":_vm.cancelEditing}}):_vm._e()],1)}),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }